import {Component, signal, inject, computed} from '@angular/core';
import {ModeGestionNavette} from './model/mode-gestion-navette.enum';
import {TrajetSelectionneService} from './services/trajet-selectionne.service';
import {isNotNullOrUndefined} from '@sigale-angular/src/utils/functions';

@Component({
	selector: 'app-trajets',
	templateUrl: './trajets.component.html',
	styleUrl: './trajets.component.scss'
})
export class TrajetsComponent {
	// Constantes
	readonly NOM_ALERTE_TRAJETS = "alerteTabTrajets";

	// Injections
	protected trajetSelectionService = inject(TrajetSelectionneService);

	// Signaux
	modeGestionNavette = signal<ModeGestionNavette>(ModeGestionNavette.SELECTION);

	// Variables
	ModeGestionNavette = ModeGestionNavette;

	// Computed
	estTrajetSelectionne = computed(() => isNotNullOrUndefined(this.trajetSelectionService.trajetSelectionne()));

	/**
	 * Bascule l'écran en mode création ou modification d'un trajet.
	 */
	basculerEnModeCreationModificationTrajet() {
		this.modeGestionNavette.set(ModeGestionNavette.CREATION_MODIFICATION);
	}

	/**
	 * Bascule l'écran en mode sélection d'un trajet.
	 */
	basculerEnModeSelectionTrajet() {
		this.modeGestionNavette.set(ModeGestionNavette.SELECTION);
	}
}
